
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "Step",
  props: {
    idx: Number,
  },
  computed: mapState(["numberOfSteps", "currentStep"]),
});
